import { CssColorVariable } from 'types/PresetStyles';

export const isDarkColor = (color: CssColorVariable) => {
  return color.name === '--color-dark';
};

export const isLightColor = (color: CssColorVariable) => {
  return color.name === '--color-light';
};
